module.exports = function(app) {
    var myModal = require("../modals/dentalModal");
    var amedaModal = require("../modals/maternityAmeda");
    var medelaModal = require("../modals/maternityMedela");
    var ssModal = require("../modals/smartShopperModal");
    //var myPharmacyModal = require("../modals/pharmacyModal");
    var hasTeleleMedicine=false;
    var teleMedicineVendorName = "DEFAULT";
    var glbFullMemberInfo;
    var glbPsp;
    var glbCurProd;
    var glbCurMember;
    var leftNavDescription = '<span data-aem-content= "MBR_FINDADOCTOR_LEFTNAVIGATION_TEXT"></span>';
    var showDentalIcon = false;

    var pharmObj;

    app.controller('pages.finder', ["$state","services", "$scope", "$sce", "$location", "finder-logic2", "modal", "finderService", "pharmacyServiceWrapper", "aemContent", "vendorSSOUtility", "sessionData", "displayOrHideItemsWrapper", "ssoHelper", "cceService",'aemContent',
        function($state, services, $scope, $sce, $location, finderLogic, modal, finderService, pharmacyServiceWrapper, aemContent, vendorSSOUtility, sessionData, displayOrHideItemsWrapper, ssoHelper, cceService,aemContent) {

            var startYourSearch = {
                heading:'<span data-aem-content="MBR_FINDADOCTOR_LEFTNAVIGATION_HEADER"></span>',
                label: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM"></span>',
                //label: 'Find a Doctor or Hospital',
                description: leftNavDescription,
                state: 'finder'
            };

            var links = []; //Array to hold the links to be displayed in the sidebar
            $scope.pharmacySso = {};

            var rxCarveOutVendor = null;
            $scope.showNewRx = false;
            $scope.isWpaNewRx = finderLogic.isWpaNewRx;
            $scope.isCpaNewRx = finderLogic.isCpaNewRx;
            $scope.isWvNewRx = finderLogic.isWvNewRx;
            $scope.isVitalsLive = ($scope.brandData.isVitalsActive) &&
            (sessionData.appConfig && sessionData.appConfig.PROVIDER && sessionData.appConfig.PROVIDER.VITALS_LIVE) ? sessionData.appConfig.PROVIDER.VITALS_LIVE.booleanValue : false;

            $scope.vitalsSmartshopper = finderLogic.getPortalSelectedPlan().vitalsSmartShopper;
            
            $scope.formsLibraryAccess = false;



            //breastpumb show checking start from here
            var firstPathSegment = (window.location.href.indexOf('denv')>-1) ? 'login' : 'login';
            $scope.defaultHref = "/" + firstPathSegment + "/#/finder";
            $scope.breastpumpShow = false;
            $scope.portalSelectedPlan = finderLogic.getPortalSelectedPlan();

            $scope.isAlbertsons = (sessionData.memberInfo.clientList[0].clientNumber ==="255721")? true : false;
            $scope.activeDrawer = "";


            $scope.getCurrentProducts =  function() {
                var currentPlans = [];
                var portalSelectedPlan =  $scope.portalSelectedPlan;
                //var millisNow = Date.parse(this.model.serverDate);
                var millisNow =  Date.parse(new Date());//Date.parse(this.model.serverDate);
                if (portalSelectedPlan && portalSelectedPlan.productList && portalSelectedPlan.productList.length > 0) {
                    var the_prods = portalSelectedPlan.productList;
                } else {
                    return currentPlans;
                }
                for (var i = 0; i < the_prods.length; i++) {
                    var millisBeginDate = Date.parse(the_prods[i].coverageBeginDate);
                    var millisEndDate = Date.parse(the_prods[i].coverageEndDate);
                    if ((millisBeginDate < millisNow) && (millisNow < millisEndDate)) {
                        currentPlans.push(the_prods[i])
                    }
                }
                return currentPlans;
            };
            $scope.hasThisPlanTypeIgnoreCase =  function(theType){
                var hasIt = -1;
                if ($scope.getCurrentProducts()) {
                    var theProductList = $scope.getCurrentProducts();
                    for (var i = 0; i < theProductList.length; i++) {

                        if ( (theProductList[i].lob.replace(" ","")).toUpperCase() == (theType.replace(" ","")).toUpperCase() ) {

                            hasIt = i;
                        } } }
                return hasIt;
            };

            $scope.isAgOnlyMember =  function() {
                var ps = $scope.portalSelectedPlan.productList;
                var isAgOnly = true;
                for (var i = 0; i < ps.length; i++) {
                    isAgOnly = (ps[i].lob != 'AG') ? false : isAgOnly;
                }
                return isAgOnly;
            };

            $scope.isTraditionalPlanMember =  function(){
                var ps = $scope.portalSelectedPlan.productList;
                var isTraditionalPlan = true;
                for (var i = 0; i < ps.length; i++) {
                    isTraditionalPlan = (ps[i].lob != 'TDM') ? false : isTraditionalPlan;
                }
                return isTraditionalPlan;
            };
            $scope.isWvMember =  function() {
                var arrWv = ["hmbcbswv", "ms", "highmarkbcbswv", "mbh:wv"];
                var brandCode =$scope.brandData.sharedBrandCode;
                // console.log("brandCode"+brandCode);
                var isWv = (arrWv.indexOf(brandCode) > -1);
                return isWv;
            };

            //ppo/epo check
            var arrPlanNames = ['PPO', 'EPO', 'HMO', 'Security Blue']; // includes Freedom Blue PPO
            var theRegion =   $scope.brandData.domain;
            var theseRegions = (theRegion == 'highmarkbcbs.com' || theRegion == 'highmarkbcbsde.com' || theRegion == 'highmarkblueshield.com' || theRegion == 'highmarkbcbswv.com' );
            var isInIncludedPlanName = false;
            var arrPlanNames = ['PPO', 'EPO','PPO BLUE','EPO BLUE'];
            for (var i = 0; i < arrPlanNames.length; i++) {
                isInIncludedPlanName = ($scope.hasThisPlanTypeIgnoreCase(arrPlanNames[i]) > -1 ) ? true : isInIncludedPlanName;
            }

            var breastPumpRegn = theseRegions ||   $scope.isWvMember();

            if( theseRegions && isInIncludedPlanName  && !$scope.isAgOnlyMember() && !$scope.isTraditionalPlanMember()){
                $scope.breastpumpShow = true;
            }

            //Forms library access points
            var formsLibraryBrands = ['hmbcbs', 'hbs', 'hmbcbswv', 'hmbcbsde', 'pp'];
            var brandCode =$scope.brandData.sharedBrandCode;
            if (formsLibraryBrands.indexOf(brandCode) > -1) {            
                $scope.formsLibraryAccess = true;                
            }

            //modals

            $scope.popSmartShopper = function(){
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/smartShopperModal',
                    controller: ssModal,
                    scope: $scope
                });
            };

            $scope.amedaHandler = function() {
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/maternityAmeda',
                    controller: amedaModal,
                    scope: $scope
                });
            };
            $scope.medelaHandler = function() {
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/maternityMedela',
                    controller: medelaModal,
                    scope: $scope
                });
            };
            $scope.openMedicalSearch = function(){
                if($scope.isVitalsLive){
                    $scope.continueToDestination = function(){
                        var targUrl = finderLogic.getVitalsSSOUrl($scope.brandData.sharedBrandCode);
                        window.open(targUrl);
                        $scope.closeModal();
                    };
                    modal.open({
                        heading: "YOU WILL BE REDIRECTED TO SAPPHIRE DIGITAL",
                        template: require('chmhom/modals/vitalsDisclaimerModal.html'),
                        scope:$scope
                    });
                } else {
                    window.location = finderLogic.getPropertyByBrandCode($scope.brandData.sharedBrandCode, 'medicalIconTarget');
                }
            };

            finderLogic.setTeamsiteContent($scope);
            // make ws call ======================================================
            finderService.getCurrentMember().then(function(fullMemberInfo) {
                glbFullMemberInfo = fullMemberInfo;
                finderLogic.setFullMemberInfo(fullMemberInfo);
                var theDomain = finderLogic.theDomain();
                var theBrand = fullMemberInfo.brand.toLowerCase();
                glbCurMember = finderLogic.setLibStorageAndReturnCurMember(fullMemberInfo);
                finderLogic.currentActiveProducts(fullMemberInfo); // sets an object that the next line needs
                var psp = glbPsp = finderLogic.getPortalSelectedPlan();

                $scope.isMedicare = finderLogic.isMedicare;
                $scope.isNewRx = finderLogic.isNewRx;
                $scope.showLongTerm = finderLogic.showLongTerm();

                // Medical Icon ==============================================================
                var currentMedicalProduct = finderLogic.specificActiveProduct('Medical');
                var latestCoverage = finderLogic.portalSelectedPlanSpecificProductByLatestCoverageEffectiveDate('Medical');
                //console.log("Latest Coverage: " + latestCoverage);
                var showMedicalIcon = false;
                var displayBCWorldWide = false;
                var displayProviderCredentials = false;

                var isBlueExtra = finderLogic.isBlueExtra();

                showMedicalIcon = (!isBlueExtra);

                if (showMedicalIcon) { // determine which url the user gets for Medical -----------------------
                    if ($scope.isVitalsLive) {
                        var medical = {
                            heading: '<span data-teamsite="MBR_FINDADOCTOR_LEFTNAV_ITEM_MEDICAL"></span>',
                            label: '<span data-teamsite="MBR_FINDADOCTOR_LEFTNAV_ITEM_MEDICAL"></span>',
                            onClick: $scope.openMedicalSearch,
                            newWindow: true
                        };
                    } else {
                        var medicalIconTarget = finderLogic.getPropertyByBrandCode(theBrand, 'medicalIconTarget');
                        //Creates the Medical Link

                        var medicalLabel = 'MBR_FINDADOCTOR_LEFTNAV_ITEM_MEDICAL';
                        // everyone except MN stays in same window
                        var newWindowValue = false;

                        // 5/24/16 - switch MN to new window for now
                        //Once all platforms go to In house, change the value to false for everyone.
                        if (theBrand.toLowerCase() === 'mincr') {
                            newWindowValue = false;
                        }
                        var medical = {
                            heading: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_MEDICAL"></span>',
                            label: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_MEDICAL"></span>',
                            href: medicalIconTarget,
                            newWindow: newWindowValue
                        };
                    }

                    links.push(medical); // pushed the medical link to the leftNav
                }

                $scope.FINDER_HIDE_DEFAULT_HERO = false;
                //TODO: Switch to using AppConfig to check if we should use the default hero or not...
                if (theBrand.toLowerCase() === 'mincr') {
                    $scope.FINDER_HIDE_DEFAULT_HERO = true;
                }

                if (latestCoverage && latestCoverage.telemedicineVendorName != null && latestCoverage.telemedicineVendorName) {
                    teleMedicineVendorName = latestCoverage.telemedicineVendorName.replace(/\s+/g, '').replace("&", "_");
                }

                if (theBrand.toLowerCase() === 'mincr') {
                    teleMedicineVendorName = ((teleMedicineVendorName && teleMedicineVendorName.toUpperCase() === 'YES') ? teleMedicineVendorName = "OnlineCareAnywhere" : "DEFAULT");
                }
                displayBCWorldWide = finderLogic.getPropertyByBrandCode(theBrand, 'displayBCWorldWide');
                displayProviderCredentials = finderLogic.getPropertyByBrandCode(theBrand, 'displayProviderCredentials');

                // TODO: MBR_FINDADOCTOR_BANNER_TEXT  for the Start Your Search text

                // PHARMACY ICON (The Pill)  ======================================================================
                // the next method returns an object with showPharmacyIcon, pharmacyTarget, and usePharmFunction;
                pharmObj = finderLogic.setupFindAPharmacy(currentMedicalProduct, theBrand);

                //backdoor url for testing the ExpressScripts SSO service
                if ($location.search()['useESSSO'] == 'true') {
                    pharmObj.usePharmFunction = true;
                }

                //Pushes Pharmacy Link into LeftNav
                $scope.pharmacyTarget = pharmObj.pharmacyTarget;
                $scope.theBrand = theBrand;
                if (pharmObj.showFindAPharmacyMod) {
                    var leftNavPharmacy = {

                        label: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_PHARMACY"></span>',
                        // label: '<span>snot</span>'
                        href: pharmObj.pharmacyTarget,
                        // href: 'snot'
                        newWindow: true

                    };
                    if (pharmObj.usePharmFunction) {
                        leftNavPharmacy.onClick = function () {
                            $scope.funcs.categoryIconFunction('pharmacy');
                        };
                    }
                    links.push(leftNavPharmacy); // pushed the pharmacy link to the leftNav
                    //console.log('Links: ' + JSON.stringify(links));

                } else {
                    // Rx carve-outs do not have drug products or a value returned for pharmacyBenefitProviderIndicator.
                    // So we must check if the member is part of a client that has a Rx carve-out pharmacy vendor.
                    var callDisplayHide = displayOrHideItemsWrapper.displayOrHideItemsCall(glbFullMemberInfo.clientList[0].clientNumber, sessionData.groupNumber, ["rxCarveOutVendor"], theBrand);

                    callDisplayHide.then(function (data) {
                        rxCarveOutVendor = null;

                        if (data && data.qualifierInfo && data.qualifierInfo.rxCarveOutVendor && data.qualifierInfo.rxCarveOutVendor.length > 0) {
                            rxCarveOutVendor = data.qualifierInfo.rxCarveOutVendor;
                            $scope.pharmacyTarget = null;

                            var leftNavPharmacy = {
                                "label": '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_PHARMACY"></span>',
                                "newWindow": true,
                                "onClick": function () {
                                    $scope.funcs.categoryIconFunction('pharmacy');
                                }
                            };
                            links.push(leftNavPharmacy);

                            $scope.arrCategoryIcons[1].showThisCategoryIcon = pharmObj.showThisCategoryIcon = true;
                            $scope.arrCategoryIcons[1].useFunction = pharmObj.useFunction = true;
                        }
                    });
                }

                // Vision Icon ===============================================================
                var showVisionIcon = false;
                // var useVisionFunction = false;
                // if they have benefitPlanType = Vision, that's aka Blue Branded
                // ToDo use the method like portalSelectedPlan in next line
                var hasBlueBranded = finderLogic.portalSelectedPlanSpecificProduct('Vision'); //specificActiveProduct('Vision');
                var isIbcHcrOrExtraBasicOrPlus = finderLogic.isIbcHcrOrExtraBasicOrPlus(fullMemberInfo); // this method includes IBC and IBCAH
                showVisionIcon = (hasBlueBranded || isIbcHcrOrExtraBasicOrPlus || hasEmbeddedVision) ? true : false;

                var inTest = (theDomain.indexOf('https://tenv') > -1 || theDomain.indexOf('https://denv') > -1);
                // 23086    13552     service    tenv3service


                //  NOTE: use this when TESTREGION url has a value:
                var tsVisionUrl = (inTest) ? "MBR_FINDADOCTOR_VISION_URL_TESTREGION" : "MBR_FINDADOCTOR_VISION_URL";
                // var tsVisionUrl = "MBR_FINDADOCTOR_VISION_URL";
                aemContent.get(tsVisionUrl).then(
                    function (content) {

                        if (brandCode === 'ndbcbs') {
                            $scope.arrCategoryIcons[2].theTarget = theDomain + "/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/VSP";

                        } else if (brandCode === 'wybcbs') {
                            $scope.arrCategoryIcons[2].theTarget = "/login/#/vision-provider-search";
                        } else {
                            $scope.arrCategoryIcons[2].theTarget = theDomain + content;
                        }


                        var visionUrl = theDomain + content;
                        var NDVisionUrl = theDomain + "/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/VSP";
                        if (showVisionIcon) {
                            var vision = {};

                            if (brandCode === 'ndbcbs') {
                                vision = {
                                    label: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_VISION"></span>',
                                    href: NDVisionUrl,
                                    newWindow: true
                                };
                            }
                            else if (brandCode === 'wybcbs') {
                                vision = {
                                    label: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_VISION"></span>',
                                    href: "/login/#/vision-provider-search",
                                    newWindow: true
                                };
                            }
                            else {
                                vision = {
                                    label: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_VISION"></span>',
                                    href: visionUrl
                                };
                            }

                        }
                        // we have to put the vision item in the correct order in the left nav
                        // at this point all the left nave items are in the links array
                        if (showDentalIcon) {
                            links.splice(links.length - 1, 0, vision);
                        } else {
                            links.push(vision); // pushed the medical link to the leftNav
                        }
                    }
                );

                // Dental Icon ===============================================================

                var useDentalFunction = false;
                var dentalUrlTarget = '';
                var currentDentalProduct = finderLogic.specificActiveProduct('Dental');
                var hasIntegratedDentalProduct = (currentMedicalProduct && currentMedicalProduct.dentalCoverage == 'true');
                var hasSomeKindOfDentalCoverage = (hasIntegratedDentalProduct || currentDentalProduct);
                var theyareDe = finderLogic.getPropertyByBrandCode(theBrand, 'regionIsDe');
                if (hasSomeKindOfDentalCoverage || isIbcHcrOrExtraBasicOrPlus) {
                    showDentalIcon = true;
                    var theyareWpaCreWv = finderLogic.getPropertyByBrandCode(theBrand, 'regionIsWpaCreWv');
                    var theyareIbccrOrIbcah = finderLogic.getPropertyByBrandCode(theBrand, 'regionIsAnIbc');

                    if (theyareWpaCreWv || theBrand === 'mincr' || theyareDe) {
                        var leaving = finderLogic.getDomainTheyAreLeaving(theBrand);


                        var theyareInABlueEdgeGroup = finderLogic.isInBlueEdgeGroup(currentMedicalProduct, currentDentalProduct);
                        useDentalFunction = (theyareInABlueEdgeGroup || theyareDe);

                    }
                    if (theyareIbccrOrIbcah) {
                        var regionIsIbcCore = finderLogic.getPropertyByBrandCode(theBrand, 'regionIsIbcCore');
                        if (regionIsIbcCore) {
                            useDentalFunction = true;

                        } else {
                            // they are IBC AH ------------------------------
                            useDentalFunction = true;

                        }
                    }

                    if (showDentalIcon) {
                        var dental = {
                            label: '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAV_ITEM_DENTAL"></span>',
                            onClick: function () {
                                var hasMedicareDentalMN = finderLogic.getPortalSelectedPlan().mnMedicareDentalIndicator;
                                if (hasMedicareDentalMN) {
                                    window.open('https://mn.ourdentalcoverage.com/find-a-dentist/?network=304');
                                } else {
                                    popDentalModal();
                                }
                            },
                            newWindow: true
                        };
                        links.push(dental); // pushed the dental link to the leftNav
                    }
                }

                if (showMedicalIcon) {
                    if (pharmObj.showFindAPharmacyMod) {
                        leftNavDescription = '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAVIGATION_MEDICALPHARMACY_TEXT"></span>';
                    }
                    else {
                        leftNavDescription = '<span data-aem-content="MBR_FINDADOCTOR_LEFTNAVIGATION_MEDICAL_TEXT"></span>';
                    }
                }

                startYourSearch.description = leftNavDescription;

                links.unshift(startYourSearch);


                //Retrieves TS content for the icons
                aemContent.get("MBR_FINDADOCTOR_MEDICAL_ICON_IMG").then(function (content) {
                    $scope.arrCategoryIcons[0].thePath = content
                });
                aemContent.get("MBR_FINDADOCTOR_PHARMACY_ICON_IMG").then(function (content) {
                    $scope.arrCategoryIcons[1].thePath = content
                });
                aemContent.get("MBR_FINDADOCTOR_VISION_ICON_IMG").then(function (content) {
                    $scope.arrCategoryIcons[2].thePath = content
                });
                aemContent.get("MBR_FINDADOCTOR_DENTAL_ICON_IMG").then(function (content) {
                    $scope.arrCategoryIcons[3].thePath = content
                });
                aemContent.get("MBR_FINDADOCTOR_TALKTODOC_LINK").then(function (content) {
                    $scope.talkToDocLink = content
                });
                var arrShowIcons = [showMedicalIcon, pharmObj.showFindAPharmacyMod, showVisionIcon, showDentalIcon];
                var numIcons = 0;
                for (var i = 0; i < arrShowIcons.length; i++) {
                    numIcons = (arrShowIcons[i] == true) ? numIcons + 1 : numIcons;
                }

                $scope.moreThanTwoIcons = (numIcons > 2);

                var medicalWindowTarget = "_blank";
                //For Minnesota, we go In house provider search. Hence, it should open in the same window.
                //Once all platforms go to In house, change the value to false for everyone.
                // if(theBrand.toLowerCase() === 'mincr'){
                //     medicalWindowTarget = "_self";
                // }
                if($scope.isVitalsLive) {
                    $scope.arrCategoryIcons = [
                        {
                            theCaption: 'MBR_FINDADOCTOR_MEDICAL_ICON',
                            //theTarget: medicalIconTarget,
                            // thePath: 'images/finder/medical.png',
                            // thePath: 'images/finder/dental.png',
                            useFunction: $scope.openMedicalSearch,
                            showThisCategoryIcon: showMedicalIcon,
                            altText: '',
                            isFirst: true,
                            newWindow: "_self",
                            iconName: 'medical'
                        },
                        {
                            theCaption: 'MBR_FINDADOCTOR_PHARMACY_ICON',
//                        theTarget: pharmObj.pharmacyTarget,
                            showThisCategoryIcon: pharmObj.showFindAPharmacyMod,
                            altText: 'Find Pharmacy Resource',
//                        useFunction: pharmObj.usePharmFunction,
                            iconName: 'pharmacy',
                            useFunction: true,
                            newWindow: '_blank'
                        },
                        {
                            theCaption: 'MBR_FINDADOCTOR_VISION_ICON',
                            // theTarget: visionUrl,
                            // thePath: 'images/finder/vision.png',
                            // thePath: 'images/finder/dental.png',
                            // useFunction: useVisionFunction,
                            showThisCategoryIcon: showVisionIcon,
                            altText: '',
                            newWindow: (theBrand.toLowerCase() === 'ndbcbs' || theBrand.toLowerCase() === 'wybcbs') ? "_blank" : "_self",
                            iconName: 'vision'
                        },
                        {
                            theCaption: 'MBR_FINDADOCTOR_DENTAL_ICON',
                            //theTarget: dentalUrlTarget,
                            // thePath: 'images/finder/dental.png',
                            useFunction: true,
                            showThisCategoryIcon: showDentalIcon,
                            altText: '',
                            iconName: 'dental'

                        }
                    ];
                } else {
                    $scope.arrCategoryIcons = [
                        {
                            theCaption: 'MBR_FINDADOCTOR_MEDICAL_ICON',
                            theTarget: medicalIconTarget,
                            // thePath: 'images/finder/medical.png',
                            // thePath: 'images/finder/dental.png',
                            showThisCategoryIcon: showMedicalIcon,
                            altText: '',
                            isFirst: true,
                            newWindow: "_self"
                        },
                        {
                            theCaption: 'MBR_FINDADOCTOR_PHARMACY_ICON',
                           // theTarget: pharmObj.pharmacyTarget,
                            showThisCategoryIcon: pharmObj.showFindAPharmacyMod,
                            altText: 'Find Pharmacy Resource',
                          // useFunction: pharmObj.usePharmFunction,
                            iconName: 'pharmacy',
                            useFunction: true,
                            newWindow: '_blank'
                        },
                        {
                            theCaption: 'MBR_FINDADOCTOR_VISION_ICON',
                            // theTarget: visionUrl,
                            // thePath: 'images/finder/vision.png',
                            // thePath: 'images/finder/dental.png',
                            // useFunction: useVisionFunction,
                            showThisCategoryIcon: showVisionIcon,
                            altText: '',
                            newWindow: (theBrand.toLowerCase() === 'ndbcbs' || theBrand.toLowerCase() === 'wybcbs') ? "_blank" : "_self",
                            iconName: 'vision'
                        },
                        {
                            theCaption: 'MBR_FINDADOCTOR_DENTAL_ICON',
                            //theTarget: dentalUrlTarget,
                            // thePath: 'images/finder/dental.png',
                            useFunction: true,
                            showThisCategoryIcon: showDentalIcon,
                            altText: '',
                            iconName: 'dental'

                        }
                    ];
            }

                /**** Right Column Items  *********************************************************************/

                var showCHC = finderLogic.getPortalSelectedPlan().chcIndicator == "true" ? true : false;
                var chcTargetUrl = null;
                if(showCHC){
                    chcTargetUrl = '#';
                }

                var showCCOE = finderLogic.getPortalSelectedPlan().ccoeIndicator;
                $scope.centerOfExcellenceShow = (showCCOE === true || showCCOE === "true");

                //Item2: My Care Navigator
                var showMyCareNavigator = finderLogic.isMyCareNavigator(theBrand);

                //Item3: BDC; Eg: https://tenv3.highmarkbcbs.com/bdc/index.html?group=01515104&userName=BOFLING&targetSite=hmbcbs
                var isBDCMember = finderLogic.isBDC();
                var showBDCToolTip = isBDCMember ? false : true;
                var bdcTitle = isBDCMember ? 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_HEADLINE_BDC' : 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_HEADLINE_NONBDC';
                var bdcContent = isBDCMember ? 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_TEXT_BDC' : 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_TEXT_NONBDC';
                var bdcHrefTitle = isBDCMember ? 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_HREFTEXT_BDC' : 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_HREFTEXT_NONBDC';
                var bdcPostHrefContent = isBDCMember ? 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_POSTHREFTEXT_BDC' : 'MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_POSTHREFTEXT_NONBDC';
                var bdcMyBenHref = isBDCMember ? '{{domain}}/bdc/index.html?group={{groupNumber}}&userName={{userAlias}}&targetSite={{brand}}' : "" ;
                var bdcMyBenText = isBDCMember ? 'MBR_FINDADOCTOR_MYBENHREFTEXT' : "";
                var bdcMyBenPostHrefText = isBDCMember ? 'MBR_FINDADOCTOR_MYBENPOSTHREFTEXT' : "";
                var bdcToolTipContent = !isBDCMember || $scope.isVitalsLive ? "MBR_FINDADOCTOR_BLUEDISTINCTIONCENTER_TOOLTIP" : "";

                var bdcMyBenHrefRefined = finderLogic.processBDCContent(bdcMyBenHref);


                //Item4: Hospital Advisor
                var isExchangeUser = finderLogic.isExchangeUser(psp);
                var showHospitalAdvisor = finderLogic.isHospitalAdvisor(psp);
                var hospitalAdvisorUrl = finderLogic.getHospitalAdvisorUrl(isExchangeUser);
                // $scope.leftColIntroParagraph = 'MBR_FINDADOCTOR_REFINEYOURSEARCH_TEXT';
                var isGeneralMills = sessionData.memberInfo.clientList[0].clientNumber === "179986";

                $scope.arrLeftColItems = [
                    {   //Item2: My Care Navigator
                        theTitle: 'MBR_FINDADOCTOR_MYCARENAVIGATOR_HEADLINE',
                        theP: 'MBR_FINDADOCTOR_MYCARENAVIGATOR_TEXT',
                        theHrefTitle: '',
                        postHrefP: '',
                        toolTipContent: '',
                        icon: 'icon-agent',
                        iconClass: 'hm-icon',
                        iconImagePath: '',
                        iconImage: false,
                        showThisFocusIcon: showMyCareNavigator,
                        showToolTip: false,
                        showNewWindowIcon: false,
                        vitalsContent: false
                    },
                    {//Item3: BDC - Search Blue Distinction
                        theTitle: bdcTitle,
                        theP: bdcContent,
                        hasHref: true,
                        theHref: (theBrand.toLowerCase() === 'wybcbs') ? 'https://www.bcbs.com/about-us/capabilities-initiatives/blue-distinction' : '#/finder',
                        theHrefTitle: bdcHrefTitle,
                        hasPostHrefP: true,
                        postHrefP: bdcPostHrefContent,
                        bdcMyBenHref: bdcMyBenHrefRefined,
                        hasBDCMyBenHrefText: (bdcMyBenText)?true:false,
                        bdcMyBenHrefText: bdcMyBenText,
                        hasBDCMyBenPostHrefText: (bdcMyBenPostHrefText)?true:false,
                        bdcMyBenPostHrefText: bdcMyBenPostHrefText,
                        toolTipContent: bdcToolTipContent,
                        icon: 'icon-clinic',
                        iconClass: 'hm-icon',
                        iconImagePath: '',
                        iconImage: false,
                        modalType: (theBrand.toLowerCase() === 'wybcbs') ? 'wybcbs' :'BDC',
                        showThisFocusIcon: true,
                        showToolTip: showBDCToolTip,
                        showNewWindowIcon: true,
                        vitalsContent: false
                    },
                    {   //Item4: Hospital Advisor temp comment
                        theTitle: 'MBR_FINDADOCTOR_COMPAREHOSPITALS_HEADLINE',
                        theP: 'MBR_FINDADOCTOR_COMPAREHOSPITALS_TEXT',
                        theHrefTitle: '',
                        postHrefP: '',
                        toolTipContent: '',
                        iconImagePath: '/content/dam/generic/en/healthco/images/finder/HospitalAdvisor.png',
                        iconImage: true,

                        altIconImage: 'Hospital Advisor Icon',
                        showThisFocusIcon: showHospitalAdvisor,
                        showToolTip: false,
                        showNewWindowIcon: false,
                        hasTitleIcon: false,
                        titleIcon: 'icon-webmd',
                        webMdStyle: 'webMdStyle',
                        vitalsContent: false
                    },
                    {   //Item1-Vitals: My Care Navigator
                        theTitle: 'My Care Navigator',
                        theP: '<a href="tel:1888BLUE428" target="_blank">Call&nbsp;<span class="iconHeightZero hm-icon icon-openInNewWindow"></span></a> 1-888-BLUE-428. We\'ll help you find a doctor, make appointments, and more',
                        theHrefTitle: '',
                        postHrefP: '',
                        toolTipContent: '',
                        icon: 'icon-agent',
                        iconClass: 'hm-icon',
                        iconImagePath: '',
                        iconImage: false,
                        showThisFocusIcon: true,
                        showToolTip: false,
                        showNewWindowIcon: false,
                        vitalsContent: true,
                        isTopLeftColSection: 'first-item'
                    },
                    {   //Item1-Vitals: My Care Navigator
                        theTitle: 'Compare Hospitals',
                        theP: '<a href="https://www.medicare.gov/hospitalcompare/search.html?cm_sp=Medicare.gov%20Provider%20Search-_-FIND%20A%20DOCTOR-_-HOME" target="_blank">Compare&nbsp;<span class="iconHeightZero hm-icon icon-openInNewWindow"></span></a> quality measures for your unique health needs.',
                        theHrefTitle: '',
                        postHrefP: '',
                        toolTipContent: '',
                        iconImagePath: '/content/dam/generic/en/healthco/images/finder/HospitalAdvisor.png',
                        iconImage: true,
                        altIconImage: 'Hospital Advisor Icon',
                        showThisFocusIcon: true,
                        showToolTip: false,
                        showNewWindowIcon: false,
                        vitalsContent: true
                    },
                    {   //Item1-Vitals: My Care Navigator
                        theTitle: 'Blue Distinction Centers',
                        theP: '<a href="http://www.bcbs.com/innovations/bluedistinction/center-list/selector-map.html?cm_sp=Blue%20Distinction%20Center%20Finder-_-FIND%20A%20DOCTOR-_-HOME" target="_blank">Find&nbsp;<span class="iconHeightZero hm-icon icon-openInNewWindow"></span></a> superior care in 6 key health categories.',
                        theHrefTitle: '',
                        postHrefP: '',
                        toolTipContent: bdcToolTipContent,
                        icon: 'icon-clinic',
                        iconClass: 'hm-icon',
                        iconImagePath: '',
                        iconImage: false,
                        showThisFocusIcon: true,
                        showToolTip: true,
                        showNewWindowIcon: false,
                        vitalsContent: true
                    }
                ];

                if(isGeneralMills){
                    var castlightTargetUrl = finderLogic.getCastlightUrl();
                    $scope.arrLeftColItems.unshift(
                        {
                            theTitle:'MBR_FINDADOCTOR_CASTLIGHT_HEADER',
                            theP: 'MBR_FINDADOCTOR_CASTLIGHT_TEXT',
                            theHrefTitle: 'MBR_FINDADOCTOR_CASTLIGHT_LINKTEXT',
                            hasHref: true,
                            theHref: castlightTargetUrl,
                            postHrefP: '',
                            toolTipContent: '',
                            icon: 'icon-savings',
                            iconClass: 'hm-icon',
                            iconImagePath: '',
                            iconImage: false,
                            showThisFocusIcon: true,
                            showToolTip: false,
                            showNewWindowIcon: false,
                            isTopLeftColSection: 'isTopLeftColSection',
                            vitalsContent: false
                        }
                    );

                }else{

                    cceService.shouldDisplay().then(function (hasCCE) {
                        if (hasCCE) {
                            var cceTargetUrl = finderLogic.getCCEUrl();

                            $scope.arrLeftColItems.unshift(
                                {   //Item1: CCE
                                    theTitle:'MBR_FINDADOCTOR_COMPARECOSTS_HEADER',
                                    theP: 'MBR_FINDADOCTOR_COMPARECOSTS_TEXT',
                                    theHrefTitle: 'MBR_FINDADOCTOR_COMPARECOSTS_LINKTEXT',
                                    hasHref: true,
                                    theHref: cceTargetUrl,
                                    postHrefP: '',
                                    toolTipContent: '',
                                    icon: 'icon-savings',
                                    iconClass: 'hm-icon',
                                    iconImagePath: '',
                                    iconImage: false,
                                    showThisFocusIcon: hasCCE,
                                    showToolTip: false,
                                    showNewWindowIcon: false,
                                    isTopLeftColSection: 'isTopLeftColSection',
                                    vitalsContent: false
                                }
                            );
                        } else if(showCHC && chcTargetUrl){
                            $scope.arrLeftColItems.unshift(
                                {   //Item1: CHC
                                    theTitle:'MBR_FINDADOCTOR_COMPARECOSTS_HEADER',
                                    theP: 'MBR_FINDADOCTOR_COMPARECOSTS_CHC_TEXT',
                                    theHrefTitle: 'MBR_FINDADOCTOR_COMPARECOSTS_CHC_LINKTEXT',
                                    hasHref: false,
                                    theHref: null,
                                    postHrefP: '',
                                    toolTipContent: '',
                                    icon: 'icon-savings',
                                    iconClass: 'hm-icon',
                                    iconImagePath: '',
                                    iconImage: false,
                                    showThisFocusIcon: showCHC,
                                    showToolTip: false,
                                    showNewWindowIcon: false,
                                    isTopLeftColSection: 'isTopLeftColSection',
                                    ngClick: function(){
                                        ssoHelper.chcSsoCall();
                                    },
                                    vitalsContent: false
                                }
                            );
                        }
                    });
                }

                /***** End of Left Column *************************/

            ////Allina Fix for MN groups
                var pennStatePortalClients = "069151,223885,240156";
                var cnBasedContent = (pennStatePortalClients.indexOf(sessionData.memberInfo.clientList[0].clientNumber) < 0) ? "": "_PSHOD";
                //generate Telemedicine vendor key.
                var teleMedicineKey = "MBR_TELEMEDICINE_PROVIDER_" + teleMedicineVendorName.toUpperCase() + cnBasedContent;
                var teleMedicineVendorKey = {
                    "SUPRESS_ONLINECARE_GROUPS" : "SUPRESS_ONLINECARE_GROUPS"
                };
                teleMedicineVendorKey[teleMedicineKey] = teleMedicineKey;
                services.rbsmbl.contentInfo().getContent(teleMedicineVendorKey).then(function(content) {

                    if (content && content.data && content.data.payload && content.data.payload.contentResponse){
                        if (($scope.brandData.sharedBrandCode.toUpperCase() == "MINCR") && (content.data.payload.contentResponse.length > 0)) {
                            var arrGrps = content.data.payload.contentResponse[0].value.replace(/\s/g, '').split(",");
                            hasTeleleMedicine = (arrGrps.indexOf(finderLogic.getPortalSelectedPlan().groupNumber) == -1) ;
                            $scope.hasTeleleMedicine = hasTeleleMedicine ;
                            $scope.teleMedicineContent = JSON.parse(content.data.payload.contentResponse[1].value);
                        }
                        else {
                            hasTeleleMedicine = true;
                            if(content.data.payload.contentResponse.length > 1) {
                                $scope.teleMedicineContent = JSON.parse(content.data.payload.contentResponse[1].value);
                            }
                            $scope.hasTeleleMedicine = true;
                            $scope.hasTeleleMedicine = ($scope.brandData.sharedBrandCode.toUpperCase() === "WYBCBS") ?  false : true;
                            if($scope.isAlbertsons){
                                $scope.teleMedicineContent = JSON.parse(content.data.payload.contentResponse[1].value);
                                $scope.teleMedicineContent.link = "Teledoc";
                            }else{
                            $scope.teleMedicineContent = JSON.parse(content.data.payload.contentResponse[1].value);
                            }
                        }
                    }
                }, function(errObj) {console.log('errObj', errObj)});

                $scope.rightColNonEmpty = false;
                if(hasTeleleMedicine == true || displayBCWorldWide == true){
                    $scope.rightColNonEmpty = true;
                }

                $scope.arrRightColItems = [
                    {
                        theTitle: 'MBR_FINDADOCTOR_BLUECARDWORLDWIDE_HEADLINE',
                        theP: 'MBR_FINDADOCTOR_BLUECARDWORLDWIDE_TEXT',
                        showItem: displayBCWorldWide,
                        showNewWindowIcon:false,
                        hasHref: false
                    },
                    {
                        theTitle: 'MBR_FINDADOCTOR_PROVIDER_CRENDTIALS_HEADLINE',
                        theP: 'MBR_FINDADOCTOR_PROVIDER_CRENDTIALS_DESCRIPTION',
                        showItem: displayProviderCredentials,
                        showNewWindowIcon:false,
                        hasHref: false
                    }

                ];


                $scope.sidebar.links = links;

            });
            // end of handling initial ws call ==========================

            window.myScope = $scope;
            $scope.theHeading = "MBR_FINDADOCTOR_PAGETITLE";
            // $scope.imgs = {};


            var popDentalModal =  function() {

                $('.isFirst-').removeClass("isActive");
                if($scope.isVitalsLive){
                    $scope.activeDrawer = 'dental';
                    $('.dental').addClass("isActive");

                } else {
                    // NOTE: in finderLogic.getTeamsiteContent( )  we set properties in $scope for the various modals
                    modal.open({
                        templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/dentalModal',
                        controller: myModal,
                        scope: $scope
                    })
                }
            };
            var popVisionModal =  function() {
                // NOTE: in finderLogic.getTeamsiteContent( )  we set properties in $scope for the various modals
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/visionModal',
                    // controller: myVisionModal,
                    scope: $scope
                })
            };
            var popPharmacyModal = function () {
                $scope.currentYear = new Date().getFullYear();
                if (!$scope.pharmacyContent) {
                    aemContent.get("MBR_FINDAPHARMACY_CONTENT").then(function (data) {
                        $scope.pharmacyContent = angular.fromJson(data);
                        $scope.pharmacyLinks = finderLogic.getPharmacyNetworks($scope.pharmacyContent, $scope.theBrand);
                    });
                }
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/pharmacyModal',
                    controller: myPharmacyModal,
                    scope: $scope
                });

            };
            var redirectNewWindow = function(theTarget){
                window.open(theTarget, '_blank');
            };

            $scope.funcs = {};
            // This handles Dental icon click and Prescription Services (the pill) click ----------------------
            $scope.funcs.categoryIconFunction = function(iconClicked) {
                // On Medical click ----------------------------------------------
                if(iconClicked == 'medical'){
                    $scope.openMedicalSearch();
                }
                // On Tooth click ------------------------------------------------
                if (iconClicked == 'dental') {
                    var hasMedicareDentalMN = finderLogic.getPortalSelectedPlan().mnMedicareDentalIndicator;
                     if (hasMedicareDentalMN) {
                        window.open('https://mn.ourdentalcoverage.com/find-a-dentist/?network=304');
                     } else {
                         popDentalModal();
                     };
                }
                //On Vision click -------------------------------------------------
                // if (iconClicked == 'vision') {
                //     console.log("Were Here");
                //     popVisionModal();

                // }
                // On Pill click -------------------------------------------------
                if (iconClicked == 'pharmacy') {
                    // check to see if the member is Medicare, and if they are in WPA/WV/CPA region.
                    if ($scope.isNewRx) {
                        if ($scope.showLongTerm) {
                            window.open(finderLogic.newRxHREF(),"searchRXWindow");
                        } else {
                            $scope.showNewRx = !$scope.showNewRx;
                        }
                    } else {
                        var sitePromo = "";
                        var curPBMIndicator = finderLogic.getPortalSelectedPlan().pharmacyBenefitProviderIndicator;

                        if (curPBMIndicator === "Medco" || curPBMIndicator === "Prime" || curPBMIndicator === "ExpressScripts") {
                            sitePromo = "cm_sp=" + curPBMIndicator + "-_-Prescription%20Services%20" + curPBMIndicator + "-_-PRESCRIPTION%20SERVICES";
                        }
                        // hit the initial service -----------------------------------
                        var prescriptServiceSsoResponse = pharmacyServiceWrapper.doPharmacySsoCall(glbFullMemberInfo, glbCurMember, glbPsp, 'locatePharmacy', rxCarveOutVendor);

                        // TODO: Update once IE fix is determined...
                        //var ssoWindowName = ('sso_pharmacy' + (glbPsp.pharmacyBenefitProviderIndicator || rxCarveOutVendor)).toLowerCase();
                        //vendorSSOUtility.launchNewSsoWindow(ssoWindowName);
                        var ssoWindowName = "_blank";

                        if (prescriptServiceSsoResponse !== null) {
                            prescriptServiceSsoResponse.then(function (vendorSSOStuff) {
                                vendorSSOUtility.genericHandleSSOResponse(vendorSSOStuff, sitePromo, ssoWindowName);
                            }, function(error) {
                                vendorSSOUtility.genericHandleSSOFailure(error, ssoWindowName);
                            });
                        } else {
                            vendorSSOUtility.genericHandleSSOFailure("", ssoWindowName);
                        }
                    }
                }
            };
            $scope.funcs.getFindDoctorTarget = function() {
                return 'https://psa.webmdhealth.com/Fprovider.aspx?f=psaIBCHighmark100109&acp=IN11,IN25,IN26,IN27,IN28,IN29,IN30&xf=ibc100109';
            };

            //******************************************************************************************
            $scope.funcs.popTeladocModal = function() {
                // NOTE: in finderLogic.getTeamsiteContent( )  we set properties in $scope for the various modals
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/teladocModal',
                    controller: myModal,
                    scope: $scope
                });
            };

            $scope.funcs.closeTeladocModal = function(theTarget) {
                if ($scope.teleMedicineContent.sso !== undefined) {
                    var ssoParams = $scope.teleMedicineContent.sso[theTarget];

                    var ssoAppConfig = null;
                    if (ssoParams && ssoParams.disableAppConfigId && ssoParams.disableAppConfigId.length > 0 && sessionData && sessionData.appConfig && sessionData.appConfig.FIND_A_DOCTOR && sessionData.appConfig.FIND_A_DOCTOR[ssoParams.disableAppConfigId]) {
                        ssoAppConfig = sessionData.appConfig.FIND_A_DOCTOR[ssoParams.disableAppConfigId];
                    }

                    if (ssoAppConfig !== null && ssoAppConfig.booleanValue === true) {
                        // If SSO is disabled by AppConfig, then just open as a URL in new window.
                        window.open($scope.teleMedicineContent.url[theTarget].href);
                    } else {
                        var ssoParameters = {
                            clientNumber: glbFullMemberInfo.clientList[0].clientNumber,
                            groupNumber: glbPsp.groupNumber,
                            targetType: ssoParams.targetType,
                            category: ssoParams.category,
                            vendorName: ssoParams.vendorName,
                            brand: $scope.brandData.sharedBrandCode.toUpperCase()
                        };
                        vendorSSOUtility.performSSO(ssoParameters, ssoParams.targetLocation, ssoParams.sitePromotionStr);
                    }
                } else {
                    window.open($scope.teleMedicineContent.url[theTarget].href);
                }
                modal.close({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/teladocModal',
                    controller: myModal,
                    scope: $scope
                });
            };

            //Act207 Modal Begin

            $scope.funcs.popAct207Modal = function() {
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/act207Modal',
                    controller: myModal,
                    scope: $scope
                });
            };


            //GENERIC FUNCTION TO POP MODAL; Configure the Modal below
            $scope.funcs.popModal = function(theModalType) {
                if(theModalType == 'BDC') {
                    $scope.funcs.popBDCModal();
                }

                if(theModalType == 'Teladoc') {
                    $scope.funcs.popTeladocModal();
                }
            };

            /**************
             BDC MODAL BEGIN
             **************/
            $scope.funcs.popBDCModal = function() {
                // NOTE: in finderLogic.getTeamsiteContent( )  we set properties in $scope for the various modals
                modal.open({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/bdcModal',
                    controller: myModal,
                    scope: $scope
                });
            };

            $scope.funcs.closeBDCModal = function(theTarget) {
                window.open('http://www.bcbs.com/innovations/bluedistinction/center-list/selector-map.html');
                //this.closeModal();
                modal.close({
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/modals/bdcModal',
                    controller: myModal,
                    scope: $scope
                });
            };
            /**************
             BDC MODAL END
             **************/

        }]);
    return [
        {
            state: "finder",
            postPassword: true,
            appConfigMaintenanceApp: 'FIND_A_DOCTOR',
            appConfigMaintenanceKey: 'FULL_MAINTENANCE',
            url: "/find-a-doctor",
            views: {
                'body@': {
                    templateUrl: 'find-a-doctor.appTemplate.html/chmhom/pages/finder',
                    controller: "pages.finder"
                }
            }
        }
    ];
};